import React from 'react';
import FoldersHeader from './FoldersHeader';
import FoldersHeaderContainer, { OwnProps } from './FoldersHeader.container';

export default FoldersHeaderContainer(
  FoldersHeader
) as React.ComponentType<OwnProps>;
